import React from 'react';

interface Props extends React.HTMLAttributes<HTMLImageElement> {
    url: string;
    preloadUrl: string;
    loading: boolean;
}

export const PreloadedImage = ({ url, preloadUrl, loading, className }: Props) => {

    return loading
        ? <img src={preloadUrl} />
        : <img className={className} src={url} />;
};